import React from 'react';

import Button from '@mui/material/Button';
import PageRow from 'components/PageRow';

interface ButtonProps {
  style?: Record<string, unknown>;
  className?: string;
  color?:
    | 'primary'
    | 'inherit'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined;
  variant?: 'contained' | 'text' | 'outlined' | undefined;
  onClick?: () => void;
  disabled?: boolean;
  children?: React.ReactNode;
  'data-testid'?: string;
}

const ButtonForm = ({
  style,
  className,
  color = 'primary',
  variant = 'contained',
  onClick,
  disabled,
  children,
  'data-testid': dataTestId,
}: ButtonProps) => {
  return (
    <PageRow>
      <Button
        style={style}
        className={className}
        color={color}
        variant={variant}
        onClick={onClick}
        disabled={disabled}
        data-testid={dataTestId}
        fullWidth
      >
        {children}
      </Button>
    </PageRow>
  );
};

export default ButtonForm;
